import './FilteredActionList-6b83ed88.css';

var classes = {"Container":"prc-FilteredActionList-Container-2A9NQ"};

export { classes as default };
